export default __webpack_public_path__ + "static/us-flag-6d429fedf7553e05ba640ee15bfde185.svg";